export default __webpack_public_path__ + "static/media/54_desktop.cf7ebe94.jpg";